module.exports = __webpack_public_path__ + "static/media/final.822b987b.svg";